import { useLocation } from 'react-router-dom'
import SearchResult from '../components/SearchResult'
import React from 'react'
import SearchForm from '../components/SearchForm'
import { useCollection } from '../hooks/useCollection'

export default function Search() {
  const queryString = useLocation().search
  const queryParams = new URLSearchParams(queryString)
  const particle = queryParams.get('q')
  const particleType = queryParams.get('t')
  const minKaiwaSegment = queryParams.get('min')
  const maxKaiwaSegment = queryParams.get('max')

  const { documents : data, error } = useCollection('corpus-v2')

  return (
    <div>
      {data && 
        <SearchForm 
            data={data} 
            particle={particle} 
            particleType={particleType} 
            minKaiwaSegment={minKaiwaSegment} 
            maxKaiwaSegment={maxKaiwaSegment}
        />
      }
      <h4 className="page-title">検索結果</h4>
      {error && <p className="error">{error}</p>}
      {data && 
        <SearchResult 
            data={data} 
            particle={particle} 
            particleType={particleType} 
            minKaiwaSegment={minKaiwaSegment} 
            maxKaiwaSegment={maxKaiwaSegment}
        />
      }
    </div>
  )
}